module.exports = __webpack_public_path__ + "static/ForTheKing0-9f19178113de6b7943cafa1b4429d081.webp";